require('../styles/tivoli.less')
import 'babel-polyfill'
import 'objectFitPolyfill'

import * as Accordion from './tivoli-accordion'
import * as AjaxForms from './ajax-forms'
import * as Visibility from './visibility'
import * as Menu from './menu'
import * as Neon from './neon'
import * as Lazyload from './lazyload'
import * as ExternalLinks from './external-links'
import * as Parallax from './parallax'
// import * as ImageGlitch from './image-glitch'
import * as ScrollJack from './scroll-jack'
import * as SmoothScroll from './smooth-scroll'
import * as Events from './events'
import * as Slides from './slides'
import * as Embeds from './embeds'
import * as Spotify from './spotify'
import * as Maps from './map'
import * as Modal from './modal'
import * as DatePicker from './date-picker'

Accordion.init()
AjaxForms.init()
Visibility.init()
Menu.init()
Neon.init()
Lazyload.init()
// ImageGlitch.init();
ExternalLinks.init()
Parallax.init()
ScrollJack.init()
SmoothScroll.init()
Events.init()
Slides.init()
Embeds.init()
Spotify.init()
Maps.init()
Modal.init()
DatePicker.init()
